import { render, staticRenderFns } from "./form-workspace-api-key.vue?vue&type=template&id=17c82782&"
import script from "./form-workspace-api-key.vue?vue&type=script&lang=js&"
export * from "./form-workspace-api-key.vue?vue&type=script&lang=js&"
import style0 from "./form-workspace-api-key.vue?vue&type=style&index=0&id=17c82782&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports